import { courses } from "../../content/courses";
import CourseItem from "../../components/CourseItem";
import React, { useContext } from "react";
import { LanguageContext } from "../../languages/languageContext";

const CoursesPage = () => {
  const language = useContext(LanguageContext).courses;

  return (
    <section>
      <h2>{language.title}</h2>

      {courses.map((course, idx) => (
        <CourseItem key={idx} course={course} />
      ))}
    </section>
  );
};

export default CoursesPage;
